module.exports = __webpack_public_path__ + "media/images/admin2/CheckBox--checked-9a28af335a6fbf567d3986450148a270.svg";